import { Box, Text, Card, Title } from '@nimbus-ds/components';
import { useTranslationCustomers } from 'domains/Customers/hooks';

function CustomerSubscriptionsCardSkeleton(): JSX.Element {
  const t = useTranslationCustomers('customerDetails.customerSubscriptions');
  return (
    <Card>
      <Card.Header>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Title as="h4">{t('title')}</Title>
        </Box>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="2">
          <Text.Skeleton width="150px" />
          <Text.Skeleton width="100px" />
          <Text.Skeleton width="275px" />
          <Text.Skeleton width="170px" />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default CustomerSubscriptionsCardSkeleton;
